import React from 'react';
import '../custom.css'; 

const VLoader = () => {
    return (
        <div className="loader-overlay">
            <div className="loader"></div>
        </div>
    );
};

export default VLoader;